
export const CONSULTATION_DURATION_OPTIONS = [
  { key: '0', value: '0', text: 'Desativado' },
  { key: '06', value: '6', text: '6 minutos' },
  { key: '10', value: '10', text: '10 minutos' },
  { key: '12', value: '12', text: '12 minutos' },
  { key: '15', value: '15', text: '15 minutos' },
  { key: '20', value: '20', text: '20 minutos' },
  { key: '30', value: '30', text: '30 minutos' },
  { key: '60', value: '60', text: '60 minutos' }
]
